































































































































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { DeedCustomerApi } from "@/api"

@Component
export default class DeedCustomerSearch extends Vue { 
    @Prop() readonly bookingId: any
    @Prop() readonly unitId: any
    @Prop() readonly deedProspectListsProps: any
    @Prop(Function) public getDeedProspect: any
    @Prop(Function) public notifcation: any
    @Prop(Function) public UpdateDeedNameByUnitId: any

    dialogConfirm = false
    dialogConfirmTextName = ""
    loading = false
    textSearchProspect = ""
    deedProspectSelected = {} as any
    deedProspectLists = [] as any[]
    _deedProspectListsProps = [] as any[]
    headers = [
        { text: '', value: 'actions', sortable: false, align: 'center'},
        { text: 'ชื่อลูกค้า TH', value: 'nameTH', width: 220 },
        { text: 'ชื่อลูกค้า ENG', value: 'nameEN', width: 220 },
        { text: 'สัญญาติ', value: 'nationalityTH', width: 100 },
        { text: 'ที่อยู่', value: 'addressTypeC' },
        { text: 'อีเมล', value: 'email' },
        { text: 'เบอร์โทรศัพท์', value: 'mobilePhone' },
    ]
    tableDatas = [] as any[]

    async btnSearch () {
        if (this.textSearchProspect === "") {
            this.notifcation("กรุณากรอกชื่อ ที่ต้องการค้นหา", "warning")
            return
        } 
        this.loading = true
        const prospectLists = await DeedCustomerApi.SearchProspectByName(this.textSearchProspect.trim())
        this.tableDatas = prospectLists
        this.loading = false
    }

    btnSelectProspect (item: any) {
        this._deedProspectListsProps = this.deedProspectListsProps
        this.dialogConfirmTextName = item.nameTH
        if (this.deedProspectLists.length != 0) {
            let countDeedProspect = this.deedProspectLists.filter((x: any) => x.prospectId == 0).length
            if (countDeedProspect == 0) {
                this.notifcation("ชื่อลูกค้าหลังโฉหนดครบแล้ว ต้องลบที่มีออกก่อน", "warning")
                return
            }
        } else {
            let countDeedProspect = this._deedProspectListsProps.filter((x: any) => x.prospectId == 0).length
            if (countDeedProspect == 0) {
                this.notifcation("ชื่อลูกค้าหลังโฉหนดครบแล้ว ต้องลบที่มีออกก่อน", "warning")
                return
            }
        }
        const checkProspctDuplicate = this._deedProspectListsProps.filter((x: any) => x.prospectId == item.prospectId).length
        if (checkProspctDuplicate > 0) {
            this.notifcation("ชื่อลูกนี้มีอยู่แล้ว", "warning")
            return
        }
        this.deedProspectSelected = item
        this.dialogConfirm = true
    }

    async btnConfrimAddDeedProspect () {
        this.dialogConfirm = false
        this._deedProspectListsProps = this.addDeedProspectObject(this._deedProspectListsProps, this.deedProspectSelected.prospectId)
        const createObjectRequestApi = this.createObjectRequestApi(this._deedProspectListsProps, this.bookingId)
        const result = await DeedCustomerApi.UpsertDeedProspect(createObjectRequestApi)
        if (result === "Success") {
            const deedNameLists = await this.getDeedProspect(this.bookingId)
            await this.UpdateDeedNameByUnitId(this.unitId, deedNameLists)
            this.notifcation("เพิ่มชื่อลูกค้าสำเร็จ", "success")
        } else {
            this.notifcation("ไม่สามารถเพื่มได้กรุณาลองอีกครั้ง", "warning")
        }
    }

    addDeedProspectObject (deedProspectLists: any[], deedProspectId: number) {
        if (deedProspectLists.length === 0) return deedProspectLists

        if (deedProspectLists[0].prospectId == 0) {
            deedProspectLists[0].prospectId = deedProspectId
            return deedProspectLists
        }
        if (deedProspectLists[1].prospectId == 0) {
            deedProspectLists[1].prospectId = deedProspectId
            return deedProspectLists
        }
        if (deedProspectLists[2].prospectId == 0) {
            deedProspectLists[2].prospectId = deedProspectId
            return deedProspectLists
        }
        if (deedProspectLists[3].prospectId == 0) {
            deedProspectLists[3].prospectId = deedProspectId
            return deedProspectLists
        }
        return deedProspectLists
    }

    createObjectRequestApi (deedProspectLists: any[], bookingid: string) {
        const data = {
            bookingid: `${bookingid}`,
            deedProspectId1: deedProspectLists[0].prospectId == 0 ? "" : `${deedProspectLists[0].prospectId}`,
            deedProspectId2: deedProspectLists[1].prospectId == 0 ? "" : `${deedProspectLists[1].prospectId}`,
            deedProspectId3: deedProspectLists[2].prospectId == 0 ? "" : `${deedProspectLists[2].prospectId}`,
            deedProspectId4: deedProspectLists[3].prospectId == 0 ? "" : `${deedProspectLists[3].prospectId}`,
        }
        return data
    }

    clearData () {
        this.tableDatas = []
    }


}
